import React from "react";
import { Heading, Tag } from "react-bulma-components";
import { Card, Block, Button } from "react-bulma-components";

function ChannelCard(props) {
  const packageList = props.package.map((i) => (
      <Button size={"small"} key={i} value={i} onClick={props.onclick}>
        {i}
      </Button>
  ));

  return (
    <Card>
      <Card.Header backgroundColor="info-light">
        <Card.Header.Title renderAs="h2" size={5}>
          {props.number} - {props.name}
        </Card.Header.Title>
      </Card.Header>
      <Card.Content>
        <Button.Group>{packageList}</Button.Group>
      </Card.Content>
    </Card>
  );
}

export default ChannelCard;
